import { getRegexFormatValidationRule } from './regex-format-validation-rule';
// Regex used by Chrome for email, sourced from https://rgxdb.com
const emailRegex = /^[a-z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i;
export const emailFormatValidationRule = getRegexFormatValidationRule(emailRegex);
//# sourceMappingURL=email-format-validation-rule.js.map